module.exports = __webpack_public_path__ + "img/maintenance.0c0a0078.svg";